import axios from "axios"
import { API_URL } from "./constants"
import { toast, Slide } from 'react-toastify';
import { encryptPayload, decryptPayload } from "./crypto";

const GATEWAY_URL = API_URL + "/api/gateway";

export function apiGet(endpoint, data = {}) {
    return gatewayRequest(endpoint, data, "get");
}

export function apiPost(endpoint, data) {
    return gatewayRequest(endpoint, data, "post");
}

export function apiPut(endpoint, data) {
    return gatewayRequest(endpoint, data, "put");
}

export function apiDelete(endpoint) {
    return gatewayRequest(endpoint, {}, "delete");
}

export function apiPatch(endpoint, data) {
    return gatewayRequest(endpoint, data, "patch");
}

function gatewayRequest(route, params, method) {
    return new Promise((resolve, reject) => {
        const token = getObject("auth") || null;

        const payload = encryptPayload({ route, method, params, token });

        axios.post(GATEWAY_URL, { payload })
            .then(response => {
                const { data: responseData } = response;
                let data;
                try {
                    data = decryptPayload(responseData.payload);
                } catch {
                    return reject({ status: 0, message: "Failed to decrypt response" });
                }

                if (data.status === 1) {
                    return resolve(data);
                }
                else if (data.status === 0) {
                    const msg = (data.message || '').toLowerCase();
                    const isAuthError = msg.includes('unauthorized') || msg.includes('session expired') || msg.includes('invalid token') || msg.includes('token expired') || msg.includes('jwt');
                    if (isAuthError) {
                        const hasAuth = getObject("auth");
                        if (hasAuth) {
                            removeAuthObjects()
                            toastError("Session expired. Please login again.");
                            setTimeout(() => {
                                window.open('/login', "_self")
                            }, 500)
                            return
                        }
                    }
                    return reject(data);
                }
                return reject(data);
            })
            .catch(error => {
                return reject(error);
            });
    });
}

export const saveObject = (key, data) => {
    let obj = JSON.stringify(data);
    localStorage.setItem(key, obj);
};

export const removeObject = key => {
    localStorage.removeItem(key);
};

export const getObject = key => {
    return JSON.parse(localStorage.getItem(key));
};

export const validateEmail = (email) => {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

export const isLoggedIn = () => {
    let auth = getObject("auth");
    if (auth) {
        if (isTokenExpired(auth)) {
            removeAuthObjects();
            return false;
        }
        return true;
    }
    return false;
};

export function isTokenExpired(token) {
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return false;
        const payload = JSON.parse(atob(parts[1]));
        return payload.exp ? payload.exp * 1000 < Date.now() : false;
    } catch {
        return false;
    }
}

export function toastSuccess(message, time = 3000) {
    toast.success(message, {
        autoClose: time,
        hideProgressBar: false,
        position: "bottom-right",
        transition: Slide
    })
    clearWaitingQueue()
}

export function toastError(message, time = 4000) {
    toast.error(message || 'Something went wrong.', {
        autoClose: time,
        hideProgressBar: false,
        position: "bottom-right",
        transition: Slide
    })
    clearWaitingQueue()
}

export function clearWaitingQueue() {
    toast.clearWaitingQueue();
}

export function removeAuthObjects() {
    removeObject('auth')
}
